'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context,
        form = context.closest('form'),
        loginform = form.find('[data-binding="logintoggle-container"]'),
        createAccountForm = form.find('[data-binding="form-section-create-account"]');

    function addLogin() {
        context.find('[data-binding="login-prompt"]').removeClass('hidden');
    }

    function addAntiForgeryToken(data) {
        data.__RequestVerificationToken = $('[name=__RequestVerificationToken]').val();
        return data;
    }

    function checkEmail() {
        var url = context.attr('data-emailcheck-url');
        createAccountForm.show(); // bring back Create Account section before each email check

        $.ajax({
            url: url,
            type: 'POST',
            data: addAntiForgeryToken({ "email": $('[data-binding="contact-details-email-address"]').val() }),
            dataType: 'json',
            async: true,
            success: function success(data) {
                if (data.success) {
                    addLogin();
                    createAccountForm.hide(); // show Create Account section if email is recognised
                }
            },
            error: function error(request, status, _error) {
                console.log(_error);
            }
        });
    }

    function swapDPblock() {
        form.find('[data-binding="data-preference-not-exists"]').hide();
        form.find('[class="data-preference-exists"]').show();
    }

    function populateForm() {
        context.find('[data-binding="login-prompt"]').addClass('hidden');

        // if title doesnt exist add it to select list (set the title to hdcTitle and check if it's empty)
        if (!form.find('[data-binding="contact-details-title"]').val($('[data-binding="hdcTitle"]').val()).val()) {
            form.find('[data-binding="contact-details-title"]').append($('<option>', {
                value: $('[data-binding="hdcTitle"]').val(),
                text: $('[data-binding="hdcTitle"]').val()
            }));
        }
        form.find('[data-binding="contact-details-title"]').val($('[data-binding="hdcTitle"]').val());

        form.find('[data-binding="contact-details-first-name"]').val($('[data-binding="hdcFirstName"]').val());
        form.find('[data-binding="contact-details-last-name"]').val($('[data-binding="hdcLastName"]').val());

        if ($('[data-binding="hdcDobRequired"]').val() === 'True') {
            form.find('[for="Under18.Yes"]').trigger('click');
            form.find('[data-binding="contact-details-dob-day"]').val($('[data-binding="hdcDobDay"]').val());
            form.find('[data-binding="contact-details-dob-month"]').val($('[data-binding="hdcDobMonth"]').val());
            form.find('[data-binding="contact-details-dob-year"]').val($('[data-binding="hdcDobYear"]').val());
        } else {
            form.find('[for="Under18.No"]').trigger('click');
        }

        form.find('[data-binding="contact-details-phone-number"]').val($('[data-binding="hdcHomePhone"]').val());
        form.find('[data-binding="contact-details-mobile-number"]').val($('[data-binding="hdcMobilePhone"]').val());

        form.find('[data-binding="enter-address-manually"]').trigger('click');

        form.find('.address-part-1').val($('[data-binding="hdaLine1"]').val());
        form.find('.address-part-2').val($('[data-binding="hdaLine2"]').val());
        form.find('.address-part-3').val($('[data-binding="hdaLine3"]').val());
        form.find('[data-binding="address-part-town"]').val($('[data-binding="hdaTown"]').val());
        form.find('[data-binding="address-part-county"]').val($('[data-binding="hdaCounty"]').val());
        form.find('[data-binding="address-part-postcode"]').val($('[data-binding="hdaPostcode"]').val());
        form.find('[data-binding="address-part-country"]').val($('[data-binding="hdaCountry"]').val());

        // if dp block has value
        if ($('[data-binding="hdcDpExists"]').val() === 'True') {

            if ($('[data-binding="hdcByPost"]').val() === "True") {
                form.find('label[for="ContactByPost.Yes"]').trigger('click');
            } else {
                form.find('label[for="ContactByPost.No"]').trigger('click');
            }

            if ($('[data-binding="hdcByEmail"]').val() === "True") {
                form.find('label[for="ContactByEmail.Yes"]').trigger('click');
            } else {
                form.find('label[for="ContactByEmail.No"]').trigger('click');
            }

            if ($('[data-binding="hdcByPhone"]').val() === "True") {
                form.find('label[for="ContactByPhone.Yes"]').trigger('click');
            } else {
                form.find('label[for="ContactByPhone.No"]').trigger('click');
            }

            if ($('[data-binding="hdcByText"]').val() === "True") {
                form.find('label[for="ContactByText.Yes"]').trigger('click');
            } else {
                form.find('label[for="ContactByText.No"]').trigger('click');
            }

            swapDPblock();

            $("#IsPreferencesExists").val("true");
        }

        $('input[name="__RequestVerificationToken"]').first().remove();
        $('.packrequest-member').remove();
        $('.supporter-details-page__separator').remove();
        $('.account-login').remove();
    }

    function showError() {
        context.find('[data-binding="inline-login-error"]').addClass('active');
    }

    function doLogin() {
        var url = context.attr('data-login-url');

        $.ajax({
            url: url,
            type: 'POST',
            data: addAntiForgeryToken({ "email": context.find('[data-binding="contact-details-email-address"]').val(), "password": context.find('[data-binding="contact-details-password"]').val() }),
            dataType: 'html',
            async: true,
            success: function success(data) {
                //populate hidden elements with data
                $('[data-binding="dvSecureKey"]').html(data);
                // if user is not authenticated
                if ($('[data-binding="userAuthenticated"]').val() === 'False') {
                    // add error
                    showError();
                } else {
                    // remove error
                    context.find('[data-binding="inline-login-error"]').removeClass('active');
                    // fill out form with data
                    populateForm();
                }

                //remove loading gif
                context.find('[data-binding="loading-gif"]').remove();
            },
            error: function error(request, status, _error2) {
                console.log(_error2);
            }
        });
    }

    function init() {

        if (form.find('[data-binding="dvSecureKey"]').length) {

            context.find('[data-binding="contact-details-email-address"]').on('blur', function () {
                context.find('[data-binding="validate-email"]').trigger('click');
            });

            context.find('[data-binding="validate-email"]').on('click', function (e) {
                e.preventDefault();
                checkEmail();
            });

            context.on('click', '[data-binding="inline-login"]', function (e) {
                e.preventDefault();
                //add loading gif
                $(this).append('<img src="/Static/images/loading.gif" class="contact-block-login__loading-gif" data-binding="loading-gif">');
                doLogin();
            });

            context.on('click', '[data-binding="logintoggle"]', function (e) {
                e.preventDefault();
                context.find('[data-binding="logintoggle-container"]').addClass('active');
            });
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/contact-block.js
// module id = 512
// module chunks = 0